export default __webpack_public_path__ + "static/media/avatar_brown_bear3.a32e2bb1.mp3";